import React, { Component } from "react";
import { Link } from "react-router";
import fileDownload from "js-file-download";

export default class RowItemCanCuCuocThanhTra extends Component {
  render() {
    const { ten, coQuanBanHanh, documentMetaData, loaiVanBan, linhVucVanBan } =
      this.props.item || [];
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{ten || ""}</td>
        <td>{coQuanBanHanh.tenCoQuan || ""}</td>
        <td>{loaiVanBan.tenLoaiVanBan || ""}</td>
        <td>{linhVucVanBan.tenLinhVuc || ""}</td>
        <td>
          <Link
            onClick={fileDownload.bind(this, documentMetaData.id, documentMetaData.name)}
            className="txt-underline txt-blue"
          >
            {documentMetaData.name || ""}
          </Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/datatable/RowItemCanCuCuocThanhTra.jsx